

















































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import ListBase from '@/lib/listbase';
import breadcrumbNav from '@/components/breadcrumb-nav.vue';
import profileMenu from '@/components/shrinkable-menu/profile-menu.vue';
import CusDatePicker from '@/components/controls/cus-date-picker.vue';
import FormBase from '@/components/helper/form-base.vue';
import User from '@/store/entities/account/user';
import Address from '@/store/entities/account/address';

@Component({
    components: { breadcrumbNav, profileMenu, CusDatePicker, FormBase },
    watch: {
        userSession: function (val) {
            if (val != null) {
                (this as any).initForm();
            }
        }
    }
})
export default class EditProfile extends ListBase {
    user: User = new User();
    address: Address = new Address();
    valid: boolean = false;
    valid2: boolean = false;
    showPass: boolean = false;
    tabModel: any = null;
    item: any = { type: 'date', prop: 'birthdate', label: 'Fecha de Nacimiento' };
    rules2: any = {
        name_req: value => !!value || 'El Nombre es obligatorio.',
        email_req: value => !!value || 'El Email es obligatorio.',
        username_req: value => !!value || 'El Numero es obligatorio.',
        pass_req: value => !!value || 'El Password es obligatoria.',
        min: v => (v && v.length >= 8) || 'Minimo 8 caracteres',
        emailMatch: () => ('The email and password you entered don\'t match'),
    };


    items2 = [
        this.gItem({ type: 'text', prop: 'username', label: 'Usuario *', required: true, size: 6, prepend_icon: 'account_circle', readonly: true }),
        this.gItem({ type: 'text', prop: 'email', label: 'Correo Electronico *', size: 6, required: true, prepend_icon: 'email' }),
        this.gItem({ type: 'text', prop: 'firstname', label: 'Nombre(s) *', size: 6, required: true, prepend_icon: 'person' }),
        this.gItem({ type: 'text', prop: 'lastname', label: 'Apellido(s)', size: 6, prepend_icon: 'person' }),
        this.gItem({ type: 'object', prop: 'document_type_id', label: 'Tipo de Documento', required: true, size: 6, onchange: this.changeDocumentType, prepend_icon: 'gavel' }),
        this.gItem({ type: 'text', prop: 'document', label: 'Documento', required: true, size: 6, minLen: 8, prepend_icon: 'gavel' }),
        this.gItem({ type: 'date', prop: 'birthdate', label: 'Fecha de Nacimiento', size: 6, prepend_icon: 'person', flexClass: 'mt-4' }),
        this.gItem({ type: 'object', prop: 'level_id', label: 'Nivel de Juego', size: 6, prepend_icon: 'stars', generalType: 'LEVELS' }),
        this.gItem({ type: 'radio', prop: 'gender_id', label: 'Genero', size: 12, generalType: 'T_GENDER', row: true }),
        
    ];


    get loading() {
        return this.$store.state.user.loading;
    }

    get userSession() {
        return this.$store.state.session.user;
    }

    changeDocumentType(id) {
        let doc = Util.getEntity(this, 'documenttype', id);
        if (doc != null)
            this.setItem(this.items, 'document', 'minLen', doc.limit);
    }

    async save() {
        if ((this.$refs.vform as any).validate()) {
            let result = await this.$store.dispatch({
                type: 'user/update',
                data: this.user
            });

            this.$store.commit('session/setUser', result);                
            this.$toast.success('Tu perfil ha sido actualizado');
        } else
            return false;
    }

    initForm() {
        this.user = Util.extend(true, {}, this.$store.state.session.user);
        if (this.$store.state.session.user != null) {
            this.address = Util.extend(true, {}, this.$store.state.session.user.address);
        }
    }
    
    mounted() {
        this.initForm();
    }

    created() {
        
        
    }
}